import treeService from "@/services/consolidation-tree/consolidation-tree";
import stimulusHistoryService from "@/services/consolidation-tree/stimulus-history";

import router from '@/router'
import moment from "moment";

const state = {
    selectedCreditor: null,
    selectedDebtBase: null,
    debtBaseList: [],
    selectedDebtNode: null,
    debtNodeList: [],
    startDate: null,
    endDate: null,
    doUpdate: false,
    haveParams: false,
    stimulusHistorys: null,
}
const mutations = {
    setSelectedCreditor(state, payload) {
        state.selectedCreditor = payload
    },
    setSelectedDebtBase(state, payload) {
        state.selectedDebtBase = payload
    },
    setDebtBaseList(state, payload) {
        state.debtBaseList = payload
    },
    setSelectedDebtNode(state, payload) {
        state.selectedDebtNode = payload
    },
    setDebtNodeList(state, payload) {
        state.debtNodeList = payload
    },
    setStartDate(state, payload) {
        state.startDate = payload
    },
    setEndDate(state, payload) {
        state.endDate = payload
    },
    setDoUpdate(state, payload) {
        state.doUpdate = payload
    },
    setStimulusHistorys(state, payload) {
        state.stimulusHistorys = payload
    },
    setHaveParams(state, payload) {
        state.haveParams = payload
    },
    clearSelectedDebtBase(state) {
        state.selectedDebtBase = null
    },
    clearSelectedDebtNode(state) {
        state.selectedDebtNode = null
    },
    clearDoUpdate(state) {
        state.doUpdate = false
    },
    clearHaveParams(state) {
        state.haveParams = false
    },
    clearStimulusHistorys(state) {
        state.stimulusHistorys = null
    },
}
const actions = {
    async loadParams({ state, commit, dispatch }) {
        if (router.app._route.query.creditor) {
            commit('setSelectedCreditor', parseInt(router.app._route.query.creditor))
            commit('setHaveParams', true)
        }
        if (router.app._route.query.baseId && router.app._route.query.creditor) {
            commit('setSelectedDebtBase', parseInt(router.app._route.query.baseId))
            commit('setHaveParams', true)
        }
        if (router.app._route.query.nodeId && router.app._route.query.baseId && router.app._route.query.creditor) {
            commit('setSelectedDebtNode', parseInt(router.app._route.query.nodeId))
        }
        if (router.app._route.query.start) {
            commit('setStartDate', router.app._route.query.start)
        } else {
            const start = moment().subtract(0, 'd')
            commit('setStartDate', moment(start._d).format("YYYY-MM-DD"))
        }
        if (router.app._route.query.end) {
            commit('setEndDate', router.app._route.query.end)
        } else {
            const end = moment().subtract(0, 'd')
            commit('setEndDate', moment(end._d).format("YYYY-MM-DD"))
        }
        if (state.haveParams){
            dispatch("searchStimulusHistory")
        }
    },


    async loadDebtBases({ state, commit }) {
        commit("setDoUpdate", true)
        await treeService.listDebtBases(state.selectedCreditor).then((resp) => {
            commit('setDebtBaseList', resp.objects)
        })
        if (!state.selectedDebtBase) {
            if (state.debtBaseList.length > 0) {

                let stimulate = state.debtBaseList.filter((db) => db.status == "STIMULATE");
                let analyzable = state.debtBaseList.filter((db) => db.status == "ANALYZABLE");
                let archived = state.debtBaseList.filter((db) => db.status == "ARCHIVED");
                commit('setDebtBaseList', stimulate.concat(analyzable, archived))
            }
            if (state.debtBaseList.length == 1) {
                commit('setSelectedDebtBase', state.debtBaseList[0].id)
            } else {
                var debtBase = state.debtBaseList.find((d) => d.status == "STIMULATE");
                if (debtBase && debtBase.id) {
                    commit('setSelectedDebtBase', debtBase.id)
                }
            }
        }
        commit("setDoUpdate", false)
    },


    async loadDebtNodes({ state, commit }) {
        commit("setDoUpdate", true)
        await treeService.listDebtNodes(state.selectedDebtBase, "name,id,active").then((resp) => {
            commit("setDebtNodeList", resp.objects)
        })
        commit("setDoUpdate", false)
    },


    async searchStimulusHistory({ state, commit }, firstRun) {
        commit("setDoUpdate", true)
        await stimulusHistoryService
          .list(state.selectedCreditor, state.startDate, state.endDate, state.selectedDebtBase, state.selectedDebtNode)
          .then((res) => {
            commit("setStimulusHistorys", res.objects);
          })
        //   .catch((error) => {
        //     console.error(error);
        //     this.$store.commit(
        //       "showSnackbar",
        //       "Houve um erro ao buscar os dados"
        //     );
        //   })
        commit("setDoUpdate", false)
      },

}
const getters = {
    selectedCreditor: (state) => state.selectedCreditor,
    selectedDebtBase: (state) => state.selectedDebtBase,
    debtBaseList: (state) => state.debtBaseList,
    selectedDebtNode: (state) => state.selectedDebtNode,
    debtNodeList: (state) => state.debtNodeList,
    startDate: (state) => state.startDate,
    endDate: (state) => state.endDate,
    doUpdate: (state) => state.doUpdate,
    haveParams: (state) => state.haveParams,
    stimulusHistorys: (state) => state.stimulusHistorys,
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};